import PropTypes from 'prop-types';
import styled from 'styled-components';

import { spacing } from '~/utils/css-mixins';
import media from '~/utils/media';

const Root = styled.div`
  display: flex;
  flex-direction: column;

  ${media.tablet`
    flex-direction: row;
  `}
`;

const MainColumn = styled.section`
  ${media.tablet`
    width: 65%;
  `}
`;

const AsideColumn = styled.aside`
  ${media.tablet`
    padding-left: ${props => props.gutter && `${spacing.siteGutter}px`};
    width: 35%;
    > *:first-child {
      margin-top: 0rem;
    }
  `}
`;

const TwoColumnLayout = ({ children, aside, gutter = true }) => (
  <Root>
    <MainColumn>{children}</MainColumn>
    {aside != null && <AsideColumn gutter={gutter}>{aside}</AsideColumn>}
  </Root>
);

TwoColumnLayout.propTypes = {
  children: PropTypes.node.isRequired,
  aside: PropTypes.element,
  gutter: PropTypes.bool,
};

export default TwoColumnLayout;
